import { BrowserRouter } from 'react-router-dom';
import { Router } from './router';
import { Header } from './components/common/Header';
import { Footer } from './components/common/Footer';
import { NotificationContainer } from './components/ui/NotificationContainer';

function App() {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary">
      <BrowserRouter>
        <Header />

        <main className="pt-20">
          <Router />
        </main>

        <Footer />
        <NotificationContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;